export default {
  projectDesc: 'A simple pagination bar, based on <strong>Vue2</strong>.',
  demo: {
    pageChangeLogs: 'page info change logs',
    gallery: 'Gallery demo',
    complete: 'full pagination bar',
    noLength: 'no page length menu',
    noPageInfo: 'no page info bar',
    noFirstLast: 'no first page, last page button',
    noPageNumber: 'no page numbers',
    border: 'border',
    displayAll: 'display all records mode',
    scopedSlots: 'scoped slot'
  },
  option: {
    vModel: 'set default page number/current page number',
    totalRow: 'the total number of records in query\n' +
          'in parent component, you need update totalRow number when it\'s change',
    info: 'set to show page info bar or no',
    language: 'the page bar language',
    pageSizeMenu: 'page length menu list, set <code>false</code> to close page length menu',
    align: 'the page bar alignment direction',
    disabled: 'enabled/disabled pagination bar',
    border: 'pagination border',
    pageNumber: 'page numbers',
    first: 'first page button',
    last: 'last page button',
    displayAll: 'add `All` item into page length menu, to display all records'
  },
  event: {
    pChange: 'when page change or page length change, plugin will emit an event to the parent',
    pageNumber: 'current page number',
    pageSize: 'the total number of records in one page'
  },
  api: {
    goPage: 'change current page',
    reload: 'reload pagination info and event'
  }
}
